import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerWallet, getCustomerWallets } from 'services/CustomerService'
import { CustomerWallet, CustomerWalletsRequest } from 'types/customers'
import { WithPaginationApiResponse } from 'types/pagination'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET, withPaginationPaging } from 'utils/pagination'

export const useGetCustomersWalletsQuery = ({
  customerReference,
  currencyCodeSearch,
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  sort = '',
}: CustomerWalletsRequest) => {
  return useQuery({
    enabled: !!customerReference,
    queryKey: reactQueryKeys.customerWallets({
      ...(customerReference && { customerReference }),
      ...(size && { size }),
      ...(page && { page }),
      ...(sort && { sort }),
      ...(currencyCodeSearch && { currencyCodeSearch }),
    }),
    queryFn: () => getCustomerWallets({ customerReference, size, page, sort, currencyCodeSearch }),
    select: (res: WithPaginationApiResponse<CustomerWallet[]>) => {
      const customerWalletsListWithPagination = withPaginationPaging<CustomerWallet[]>(res)
      return customerWalletsListWithPagination
    },
  })
}

export const useGetCustomersWalletQuery = (walletId: string, enabled = false) => {
  return useQuery({
    enabled,
    queryKey: reactQueryKeys.customerWallet(walletId),
    queryFn: () => getCustomerWallet(walletId),
  })
}
